module.exports = __webpack_public_path__ + "static/media/laws.cc52183a.pdf";